import {createElement, type JSX} from 'react'

interface ImageProps {
	src: string
	className?: string
	alt?: string
	style?: unknown
	height?: number
	width?: number
	loader?: (props: ImageLoaderProps) => string
}

interface ImageLoaderProps {
	src: string
	width: number
	quality: number
}

export const Image = (props: ImageProps): JSX.Element => {
	try {
		const {width: imgWidth, height} = props

		const nextImageComponent =
			// @ts-expect-error return the default on resolved package
			require.resolve('next/image').default as React.ComponentType<
				typeof props
			>

		return createElement(nextImageComponent, {
			...props,
			loader: ({src, width, quality}: ImageLoaderProps) =>
				`${src}?w=${width}&q=${quality || 75}&auto=format`,
			...(!imgWidth || !height ? {fill: true} : {}),
		})
	} catch {
		return createElement('img', {...props})
	}
}
